import { Alert } from 'components/ui/alert';
import { LoadingMessage } from 'components/Loader/LoadingMessage';
import { ResponsiveChartContainer } from 'eazychart-react';
import { useChart } from 'hooks/useChart';
import {
  ChartIndicatorsProvider,
  useChartIndicators,
} from 'hooks/useChartIndicators';
import { FC, useEffect } from 'react';

type ChartProps = {
  chartId: number;
};

const ChartContent: FC<ChartProps> = ({ chartId }) => {
  const { data, isLoading, error, ChartComponent } = useChart(chartId);
  const { selectedData: chartData, setSelectedIndicatorIds } =
    useChartIndicators();
  const chart = data?.data;
  const indicatorIds = chart?.indicators;

  useEffect(() => {
    setSelectedIndicatorIds(indicatorIds ?? []);
  }, [indicatorIds, setSelectedIndicatorIds]);

  if (error) {
    return (
      <Alert variant="destructive">Impossible de charger le graphique</Alert>
    );
  }

  if (isLoading || !chart) {
    return <LoadingMessage />;
  }

  return (
    <div className="relative h-[300px] overflow-visible">
      <ResponsiveChartContainer>
        <ChartComponent
          data={chartData}
          {...chart.props}
          // scopedSlots={{
          //   // LegendComponent: () => null,
          //   TooltipComponent: undefined,
          // }}
        />
      </ResponsiveChartContainer>
    </div>
  );
};

export const Chart: FC<ChartProps> = ({ chartId }) => {
  return (
    <ChartIndicatorsProvider>
      <ChartContent chartId={chartId} />
    </ChartIndicatorsProvider>
  );
};
